import merge from 'lodash-es/merge';
import useDefaultChartOptions from '@/components/charts/useDefaultChartOptions';
import usePieChartOptions from '@/components/charts/usePieChartOptions';
import { roundIfNecessary } from '@/util/helpers/numbers';

export const getEndedEventsWithHelpConfig = (id: string, group: number, endedChartsStartedWithHelp: number, numberOfEndedCourseStatisticEvents: number) => {
    return {
        id,
        group,
        printTitle: 'Startet forløb selv vs. startet med støtte fra kommune (afsluttede forløb)',
        options: merge(useDefaultChartOptions(), usePieChartOptions(), {
            title: { text: 'Startet forløb selv vs. startet med støtte fra kommune' },
            series: {
                tooltip: {
                    pointFormatter() {
                        return `<span style="color:${(this as any).color}">●</span> Antal: <b>${(this as any).y}</b><br/><span style="color:${(this as any).color}">●</span> Fordeling: <b>${roundIfNecessary(
                            (this as any).percentage,
                            1
                        )}%</b><br/>`;
                    },
                },
                data: [
                    { name: 'Startet selv', y: endedChartsStartedWithHelp },
                    { name: 'Startet med hjælp', y: numberOfEndedCourseStatisticEvents - endedChartsStartedWithHelp },
                ].map((currentDataPoint) => {
                    return {
                        ...currentDataPoint,
                        dataLabels: {
                            distance: currentDataPoint.y > 0 ? '-50%' : '30',
                        },
                    };
                }),
            },
        }),
    };
};
